import { StateType as State } from "common/types/index";

import {
  AllowedCallTypes,
  makeApiStatesSelectorsFactory,
  makeCrudStateSelectors
} from "seneca-common/utils/apiStates";

import { courseEnrollmentsCrudConfig } from "../consts";
import { getCourseEnrollmentsSlice } from "./";

const getCourseEnrollmentsMetaSlice = (state: State) =>
  getCourseEnrollmentsSlice(state).get("meta");

const courseEnrollmentCrudStateSelectors = makeCrudStateSelectors(
  // @ts-ignore
  getCourseEnrollmentsMetaSlice,
  courseEnrollmentsCrudConfig
);

export const getFetchCourseEnrollmentsStarted = (state: State): boolean =>
  courseEnrollmentCrudStateSelectors.fetchAll.getStarted(state);

export const getFetchCourseEnrollmentsSuccess = (state: State): boolean =>
  courseEnrollmentCrudStateSelectors.fetchAll.getSuccess(state);

export const getFetchCourseEnrollmentsError = (state: State): boolean =>
  courseEnrollmentCrudStateSelectors.fetchAll.getError(state);

export const getFetchCourseEnrollmentsFinished = (state: State): boolean =>
  getFetchCourseEnrollmentsSuccess(state) ||
  getFetchCourseEnrollmentsError(state);

export const courseEnrollmentsHaveFinishedFetching = (state: State): boolean =>
  getFetchCourseEnrollmentsError(state) ||
  getFetchCourseEnrollmentsSuccess(state);

export const courseEnrollmentIsDeleting = (
  state: State,
  courseId: string
): boolean =>
  courseEnrollmentCrudStateSelectors.delete.getStarted(state, courseId);

export const getCourseEnrollmentDeleteSuccess = (
  state: State,
  courseId: string
): boolean =>
  courseEnrollmentCrudStateSelectors.delete.getSuccess(state, courseId);

export const getCourseEnrollmentDeleteError = (
  state: State,
  courseId: string
): boolean =>
  courseEnrollmentCrudStateSelectors.delete.getError(state, courseId);

export const getCourseEnrollmentDeleteFinished = (
  state: State,
  courseId: string
): boolean =>
  getCourseEnrollmentDeleteSuccess(state, courseId) ||
  getCourseEnrollmentDeleteError(state, courseId);

export const courseEnrollmentDeleteHasFinished = (
  state: State,
  courseId: string
): boolean =>
  getCourseEnrollmentDeleteError(state, courseId) ||
  getCourseEnrollmentDeleteSuccess(state, courseId);

export const makeApiStatesSelectors = makeApiStatesSelectorsFactory(
  courseEnrollmentsCrudConfig
);

const {
  hasStarted: courseEnrollmentIsCreating,
  didSucceed: getCourseEnrollmentCreateSuccess,
  didError: getCourseEnrollmentCreateError,
  hasFinished: courseEnrollmentCreateHasFinished,
  getErrorMessage: getCourseEnrollmentCreateErrorMessage
  // @ts-ignore
} = makeApiStatesSelectors(getCourseEnrollmentsMetaSlice)[
  AllowedCallTypes.CREATE
];

export {
  courseEnrollmentIsCreating,
  getCourseEnrollmentCreateSuccess,
  getCourseEnrollmentCreateError,
  courseEnrollmentCreateHasFinished,
  getCourseEnrollmentCreateErrorMessage
};
